// Libs
import React from 'react'
import _ from 'lodash'
import { DownloadCloud, Eye, ArrowUp, Layers } from 'react-feather'

// CSS
import './styles.scss'

// Components
import Button from '../../../../components/Button'

// Constansts
import { getlinkToTJ } from '../../../../constants/others'

const CaptureCardCase = ({ lawsuit, form, changeField, saveField, fetchLawyer, changeLawsuitSelected, changeCardType, validateForm, changeVisible, changeExportCases }) => {
  const gridAreaArray = ['1 / 1 / 2 / 2', '1 / 2 / 2 / 3', '1 / 3 / 2 / 4', '1 / 4 / 2 / 5', '1 / 5 / 2 / 6', '1 / 6 / 2 / 7',
    '2 / 1 / 3 / 4', '2 / 4 / 3 / 6', '2 / 6 / 3 / 8',
    '3 / 1 / 4 / 2', '3 / 2 / 4 / 4', '3 / 4 / 4 / 5', '3 / 5 / 4 / 7', '3 / 7 / 4 / 8',
    '4 / 1 / 5 / 2', '4 / 2 / 5 / 4', '4 / 4 / 5 / 5', '4 / 5 / 5 / 8',
    '5 / 1 / 6 / 2', '5 / 2 / 6 / 5']

  const getValue = (field) => {
    return form.filter(item => item.field === field)[0].value
  }

  const changeCapturedStatus = () => {
    let newCapturedStatus = 'Arquivado'

    if (isArchived) {
      newCapturedStatus = 'Novo Processo'

      changeField(0, 'capturedStatus', newCapturedStatus)
    } else {
      changeCardType('archive')

      setTimeout(() => {
        changeLawsuitSelected('')
      }, 2000);
    }

    saveField(getValue('number'), 'capturedStatus', newCapturedStatus)
  }

  const isArchived = getValue('capturedStatus') === 'Arquivado'
  const link = getlinkToTJ(getValue('number'), getValue('uf'))

  return (
    <div className="capture-card-case">
      {form.map((item, idx) => (
        <div
          key={idx}
          className={item.error ? 'capture-card-case__info capture-card-case__info--error' : 'capture-card-case__info'}
          style={{ gridArea: gridAreaArray[idx] }}>
          <span>{item.label}</span>
          {!item.editable &&
            <div>{item.format ? item.format(item.value) : item.value}</div>
          }
          {item.editable && item.type === 'input' &&
            <input
              value={item.value}
              onChange={e => changeField(0, item.field, item.normalize ? item.normalize(e.target.value) : e.target.value)}
              onBlur={() => {
                if (item.field === 'lawyerOabNumber') {
                  const lawyerOabUf = getValue('lawyerOabUf')
                  item.value.length <= 6 && changeField(0, item.field, '0'.repeat(6 - item.value.length) + item.value)

                  fetchLawyer(item.value, lawyerOabUf)
                }

                if (item.field === 'lawyerOabUf') {
                  const lawyerOabNumber = getValue('lawyerOabNumber')

                  fetchLawyer(lawyerOabNumber, item.value)
                }

                saveField(lawsuit.number, item.field, item.value)
              }} />
          }
          {item.editable && item.type === 'select' &&
            <select
              onChange={(e) => changeField(0, item.field, e.target.value, null, null)}
              onBlur={(e) => saveField(lawsuit.number, item.field, item.value)}
              value={item.value}>
              {item.options.map(option => {
                return (
                  <option
                    key={option.value}
                    value={option.value}>
                    {option.label}
                  </option>
                )
              })}
            </select>
          }
        </div>
      ))}
      {!lawsuit.caseId
        &&
        <div className='capture-card-case__button--wrapper' style={{ gridArea: '5 / 6 / 6 / 7' }}>
          <Button
            resize={false}
            onClick={() => changeCapturedStatus()}>
            {isArchived ? 'Desarquivar' : 'Arquivar'}
          </Button>
        </div>}
      <div className='capture-card-case__button--wrapper' style={{ gridArea: '5 / 7 / 6 / 8' }}>
        {lawsuit.caseId ?
          <Button
            type="submit"
            resize={false}>
            <a href={`https://comacordo.com.br/meus-casos/${lawsuit.caseId}`} target='_blank'>
              Visualizar
            </a>
          </Button>
          :
          <Button
            type="submit"
            disabled={isArchived}
            resize={false}
            onClick={() => validateForm(form)}>
            Inserir Caso
          </Button>
        }
      </div>
      <div className='capture-card-case__icon'>
        {link &&
          <Eye onClick={() => window.open(link)} />
        }
        {!_.isEmpty(lawsuit.documents) &&
          <Layers onClick={() => changeCardType('documents')} />
        }
        <DownloadCloud onClick={() => {
          changeVisible("_export", true)
          changeExportCases("one")
        }} />
        <ArrowUp onClick={() => changeLawsuitSelected('')} />
      </div>
    </div>
  )
}

export default CaptureCardCase
